import React from "react";
import { BodypartType } from "@growth-machine-llc/stridist-api-client";
import { BodypartTypeLabels } from "../constants";
import { ExerciseCategoriesFilter } from "./ExerciseCategoriesFilters";
import { mapFilters } from "./filterUtils";

export const BodypartFilter = React.memo(function BodypartFilter({
  onChange,
  contextFilters,
  className,
}: {
  onChange?: (selected: BodypartType[]) => void;
  contextFilters?: BodypartType[];
  className?: string;
}) {
  const [filters, setFilters] = React.useState(() =>
    mapFilters(BodypartType, contextFilters),
  );

  React.useEffect(() => {
    setFilters(mapFilters(BodypartType, contextFilters));
  }, [contextFilters]);

  const extractSelected = React.useCallback(
    (filters: Record<BodypartType, boolean>): BodypartType[] =>
      Object.entries(filters)
        .filter(([_, checked]) => checked)
        .map(([key]) => key as BodypartType),
    [],
  );

  const handleChange = React.useCallback(
    (newFilters: Record<BodypartType, boolean>) => {
      const selected = extractSelected(newFilters);
      onChange?.(selected);
    },
    [extractSelected, onChange],
  );

  return (
    <ExerciseCategoriesFilter
      filters={filters}
      onChange={handleChange}
      filterTypesLabels={BodypartTypeLabels}
      labelType="Bodyparts"
      className={className}
    />
  );
});
